/* src/app/private/components/registration/delete-bulk-registration/delete-bulk-registration.component.scss */
/*# sourceMappingURL=delete-bulk-registration.component.css.map */
